// src/services/api.js
import axios from 'axios';

const API_URL = 'https://app.writeapp.in';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Fully defined profile API
export const profileApi = {
  getCurrentProfile: () => api.get('/profile/me'),
  getProfileByuserId: (userId) => api.get(`/profile/user/${userId}`),
  updateProfile: (data) => api.put('/profile/me', data),
  updateProfilePicture: (formData) => api.put('/profile/me', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  createProfile: (formData) => api.post('/profile/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};

export default api;
